/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Fri Dec 13 2024
 **/

import { usePhoneCall, useSidebarActions } from "@/frameworks/core/hooks";
import { Button, Column, Icon, Row, Typography } from "@/frameworks/designStuff";
import { Configure } from "@/frameworks/libraries";
import { useTheme } from "@emotion/react";
import { _T } from "@rfice/language";

export default function EndScreenShare({ callID }: { callID?: string }) {
	const { colors } = useTheme();
	const phoneCall = usePhoneCall();
	const sidebarActions = useSidebarActions();
	const endScreenShare = () => {
		phoneCall.screen_update(callID ?? "", Configure.userID, "stop");

		if (sidebarActions.isOpen("PhoneDetail")) {
			sidebarActions.hide("PhoneDetail");
		}
		phoneCall.popup.show({
			callID: callID ?? "",
			callerID: Configure.userID,
			uiType: "floating"
		});
	};
	return (
		<Column
			style={{
				width: "100%",
				height: "220px",
				backgroundColor: colors.neutral_60_100,
				borderRadius: "8px"
			}}
			gap={8}
			horizonAlign="center"
			verticalAlign="center"
		>
			<Row gap={6}>
				<Icon name="ScreenShare24" size={20} fill={colors.neutral_00_100} />
				<Typography typoColor="neutral_00_100" typoSize="Title3">
					{_T("내 화면 공유 중")}
				</Typography>
			</Row>
			<Button filled="neutral" style={{ borderRadius: "100px" }} onClick={endScreenShare}>
				{_T("공유종료")}
			</Button>
		</Column>
	);
}
